import React, { useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { onTabActive } from '../../../../../packs/shop/features/member-center';

const TabContent = ({ url, children }) => {
  const ref = useRef(null);

  /**
   * Listen Tab change associated url change
   *  Note: Tabs Component use angular Use, switching logic cannot be extracted
   */
  const listenTabActive = useCallback(() => {
    if (url && ref.current) {
      onTabActive($(ref.current).parent(), () => {
        history.replaceState(null, null, `${url}${location.search}`);
      });
    }
  }, [url]);

  useEffect(() => {
    listenTabActive();
  }, [listenTabActive]);

  return (
    <div ref={ref} className="member-center__tab-content">
      {children}
    </div>
  );
};

TabContent.propTypes = {
  url: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
  ]),
};

export default TabContent;
